import { createImageHeader } from '@vfde-brix/ws10/image-header';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * ImageHeader BRIX component
 *
 */
export const mountImageHeader = (id: string) => {
    const imageHeaderContainer = document.getElementById(id);

    return imageHeaderContainer && createImageHeader(imageHeaderContainer, NO_PATTERN_BUSINESS_LOGIC);
};
